// @ts-nocheck
import React, { FC } from 'react';

const media = bp => props => props.theme.breakpoints.up(bp);

interface ImageAdornmentProps {
  src: string;
}

const ImageAdornment: FC<ImageAdornmentProps> = ({ src }) => {
  return (
    <div className="relative mr-12 sm:m-0">
      <div className="relative bg-white z-2 p-8 sm:p-12 md:p-16 lg:p-24">
        <img src={src} alt="" className="w-full" />
      </div>

      <div
        className="bg-primary-main absolute z-1"
        css={`
          height: 49.44px;
          width: 49.44px;
          bottom: -11px;
          right: -11px;
          ${media('sm')} {
            height: 67px;
            width: 67px;
            bottom: -12px;
            right: -12px;
          }
          ${media('md')} {
            height: 89px;
            width: 89px;
            bottom: -16px;
            right: -16px;
          }
          ${media('lg')} {
            height: 136px;
            width: 136px;
            bottom: -24px;
            right: -24px;
          }
        `}
      />
    </div>
  );
};

export default ImageAdornment;
